import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const PlaceRequestSent = ({ location, match, history }) => {
    const { id: placeId } = match.params;
    const { bookingRequest } = location.state;
    const bookingMessage = bookingRequest ? bookingRequest.message : "";
    // Only allow user to access this page through redirect from the booking
    useEffect(() => {
        if (bookingRequest === undefined) {
            history.push(`/place/${placeId}`);
        }
    }, []);

    return (
        <div id="placeRequestSent" className="container">
            <h1>Booking Request Submitted</h1>
            <p>Thank you for your booking request. The host has received the following information:</p>

            <p><strong>Check-in:</strong> {bookingRequest.start_date}</p>
            <p><strong>Check-out:</strong> {bookingRequest.end_date}</p>
            <p><strong>Nº of Guests:</strong> {bookingRequest.guests}</p>
            {
                bookingMessage !== "" && (
                    <div className="message">
                        <p><strong>Message:</strong></p>
                        <p>{bookingRequest.message}</p>
                    </div>
                )
            }

            <p>The host will review your request and notify you as soon as possible!</p>
            <p>You can view the status of your request in the Requests section of your member dashboard by clicking the button below</p>
            <div className='w-100 d-flex justify-content-center'>
                <Link
                    className="btn btn-green font-open-sans font-size-14 font-weight-700 text-white text-decoration-none"
                    to={{pathname: `/dashboard/requests/pending`}}
                    dangerouslySetInnerHTML={{
                        __html: `Click here to view booking`
                    }}
                />
            </div>
        </div>
    )
}

export default PlaceRequestSent;
